module.exports = __webpack_public_path__ + "img/gyms-icon.1699ca35.svg";